import map from "lodash/map";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import { getKjoretoyTyper } from "../../../actions/kjoretoyTyperActions";
import * as title from "../../../constants/titles";
import Table from "../../Common/Tables/BaseTable";
import KjoretoyTyperModal from "./UpdateModals/KjoretoyTyperModal";

export default function KjoretoyTyperList({ authorizedToCreateAndEdit }) {
  const kjoretoyTyper = useSelector((state) => state.kjoretoyTyper);
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = title.grunndataKjoretoyTyper;
    dispatch(getKjoretoyTyper());
  }, [dispatch]);

  const headerRow = ["Kode", "Navn", ""];
  return (
    <div className="table-wrapper-horizontal-scroll">
      <Table id="kjoretoyType-liste" headerRow={headerRow} defaultStyle striped>
        <tbody>
          {map(kjoretoyTyper, (kjoretoyType) => (
            <tr key={`kjoretoyTyperTableBodyTr${kjoretoyType.id.toString()}`}>
              <td>{kjoretoyType.kode}</td>
              <td>{kjoretoyType.navn}</td>
              <td>
                {authorizedToCreateAndEdit && (
                  <KjoretoyTyperModal kjoretoyType={kjoretoyType} />
                )}
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
}
